<div class="app-spinner">
	<mat-spinner></mat-spinner>
</div>